// Настройки логистики — зеркалят backend (logistics_settings), в пакете типов их пока нет
export enum EDeliveryZone {
  Z1 = 'Z1',
  Z2 = 'Z2',
  Z3 = 'Z3',
  Z4 = 'Z4'
}

export enum EDeliveryCheckCategory {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH'
}

export enum EDeliveryWeightCategory {
  LIGHT = 'LIGHT',
  MEDIUM = 'MEDIUM',
  HEAVY = 'HEAVY'
}

export enum EDeliverySubsidyReason {
  FREE_BY_DELIVERY_COST_LIMIT = 'FREE_BY_DELIVERY_COST_LIMIT',
  FREE_BY_MATRIX = 'Бесплатно по матрице',
  PARTIAL_SUBSIDY = 'Частичная субсидия',
  LOW_PRICE_PER_KG = 'Низкая цена за килограмм',
  DISTANT_ZONE = 'Далёкая зона',
  SMALL_CHECK = 'Маленький чек',
  WEIGHT_OUT_OF_RANGE = 'Вес вне диапазона'
}

export interface IDeliverySubsidyRule {
  key: string
  minimum_order_sum: number
  weight_from_kg: number
  weight_to_kg: number
  commission_compensation_percent: number
}

export interface IDeliveryPolicySettings {
  minimum_item_price_per_kg: number
  free_delivery_max_cost: number
  platform_commission_subsidy_limit_percent: number
  delivery_subsidy_rules: IDeliverySubsidyRule[]
  delivery_policy_version: number
}

export interface ILogisticsSettings {
  _id: string
  courier_delivery_days_from: number
  pvz_delivery_days_from: number
  minimum_item_price_per_kg: number
  free_delivery_max_cost: number
  platform_commission_subsidy_limit_percent: number
  delivery_subsidy_rules: IDeliverySubsidyRule[]
  delivery_policy_version: number
  createdAt: string
  updatedAt: string
}

export interface IUpdateLogisticsSettings {
  courier_delivery_days_from?: number
  pvz_delivery_days_from?: number
  minimum_item_price_per_kg?: number
  free_delivery_max_cost?: number
  platform_commission_subsidy_limit_percent?: number
  delivery_subsidy_rules?: IDeliverySubsidyRule[]
}
